import styled from 'styled-components'
import React from 'react'

const TitleStyle = styled.div.attrs<{ className?: string }>((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;

  &::before {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: red;
    content: '';
  }

  h1 {
    margin: 0;
    margin-left: 5px;
  }
`

export const Title: React.FC<{ className?: string }> = (props) => (
  <TitleStyle className={props.className}>
    <h1 className="text-2xl font-bold ml-2">{props.children}</h1>
  </TitleStyle>
)
